export const WisselType = [
    "NORMAL_SWITCH:ANGLE=LEFT",
    "NORMAL_SWITCH:ANGLE=RIGHT",
    "SYMMETRIC_SWITCH",
    "ENGLISH_SWITCH",
    "HALF_ENGLISH_SWITCH",
    "INTERSECTION_SWITCH",
];
export const HoekVerhouding = [
    "1_9", //0
    "1_15", //1
    "1_4,5_2x1_9", //2
    "1_12", //3
];
export const SpoorStaafProfiel = [
    "54E1", //0
    "54E5", //1
    // "540"//2
];
export const BoogStraal = [
    "195", //0
    "725", //1
    "390", //2
    "204", //3
    "260", //4
    "400", //5
    "465", //6
    "1200", //7
    "600", //8
];
export const WisselLigger = [
    "CONCRETE",
    "WOOD" // WOOD!DISABLED
];
